/**
 * Shared "Use in Create" / "Edit in Create" behavior for tools.
 * Tools (Voice & Tone, AI Content Creation) prefill the Create page by writing
 * to sessionStorage and navigating to /dashboard/create. The Create page
 * reads this key on mount and clears it after applying.
 *
 * Usage from a tool page:
 *   import { prefillCreatePage } from '@/lib/createPagePrefill';
 *   import { useRouter } from 'next/navigation';
 *   const router = useRouter();
 *   prefillCreatePage({ content: text });
 *   router.push('/dashboard/create');
 *
 * Storage key: createPagePrefill
 * Shape: { title?: string; content?: string }
 */

export const CREATE_PREFILL_KEY = 'createPagePrefill';

export type CreatePrefillPayload = {
  title?: string;
  content?: string;
};

export function prefillCreatePage(payload: CreatePrefillPayload): void {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.setItem(CREATE_PREFILL_KEY, JSON.stringify(payload));
  } catch (_) {
    // ignore quota or disabled storage
  }
}
